import { render, staticRenderFns } from "./UserGroupFilter.vue?vue&type=template&id=514bbf98"
import script from "./UserGroupFilter.vue?vue&type=script&lang=js"
export * from "./UserGroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports